import { FunctionComponent, useContext } from 'react'
import styled, { css } from 'styled-components'
import { ellipsis } from 'polished'
import contextStandardTeaser from '@contexts/standardTeaser'
import { StandardTeaserLayoutContextType } from '@contexts/standardTeaser'
import { CatchwordProps } from '@widgets/Teaser/standard/types'
import {
  desktopCSS,
  regularMobileCSS,
  smallMobileCSS,
  tabletCSS,
} from '@measures/responsive'

type StyledCatchwordProps = Pick<
  StandardTeaserLayoutContextType,
  | 'hasVideoOnlyStyle'
  | 'isInMegaModule'
  | 'hasMiniDesktopStyle'
  | 'hasExtraLargeTabletStyle'
>

const { StandardTeaserLayoutContext } = contextStandardTeaser

const StyledCatchword = styled.div<StyledCatchwordProps>`
  ${({
    theme: {
      fonts: { goodOT: goodOTFontName },
      colors: {
        grey: { grey_10, grey_80 },
      },
    },
    hasVideoOnlyStyle,
    isInMegaModule,
    hasMiniDesktopStyle,
    hasExtraLargeTabletStyle,
  }) => {
    return css`
      font-family: ${goodOTFontName}, 'Arial Narrow', Impact;
      font-weight: 500;
      line-height: 1.1;
      color: ${hasVideoOnlyStyle ? grey_10 : grey_80};
      > strong {
        color: ${hasVideoOnlyStyle ? grey_10 : grey_80};
        font-weight: 500;
      }
      > p {
        margin: 0;
      }

      ${desktopCSS(css`
        font-size: ${hasMiniDesktopStyle ? '15px' : '17px'};
        ${ellipsis('100%', hasMiniDesktopStyle ? 2 : 1)};

        /* //! Needed because "ellipsis()" returns "display: inline-block;" 
         * //! when the second argument is 1. 
         */
        display: block;
        margin-bottom: ${hasMiniDesktopStyle ? '2px' : '0px'};
      `)}

      ${tabletCSS(css`
        font-size: ${isInMegaModule && !hasExtraLargeTabletStyle
          ? '15px'
          : '17px'};
        ${ellipsis('100%', isInMegaModule ? 2 : 1)};

        /* //! Needed because "ellipsis()" returns "display: inline-block;" 
         * //! when the second argument is 1. 
         */
        display: block;
        margin-bottom: ${isInMegaModule ? '2px' : '0px'};
      `)}

      ${smallMobileCSS(css`
        font-size: 15px;
        margin-bottom: 2px;
      `)}
        
      ${regularMobileCSS(css`
        font-size: 17px;
        margin-bottom: 2px;
      `)}
    `
  }}
`

const Catchword: FunctionComponent<CatchwordProps> = ({ children }) => {
  const {
    hasVideoOnlyStyle,
    isInMegaModule,
    hasMiniDesktopStyle,
    hasExtraLargeTabletStyle,
  } = useContext(StandardTeaserLayoutContext)

  return (
    <StyledCatchword
      hasVideoOnlyStyle={hasVideoOnlyStyle}
      isInMegaModule={isInMegaModule}
      hasMiniDesktopStyle={hasMiniDesktopStyle}
      hasExtraLargeTabletStyle={hasExtraLargeTabletStyle}
      dangerouslySetInnerHTML={{
        __html: children,
      }}
    />
  )
}

export default Catchword
